import React from "react";
import { MapPin, Phone } from "lucide-react";
import { cn } from "@/lib/utils";

export interface Branch {
  name: string;
  address: string;
  phones: string[];
  extensions?: string;
  mapQuery: string;
}

interface BranchCardProps {
  branch: Branch;
  onClick?: () => void;
  className?: string;
}

export function BranchCard({ branch, onClick, className }: BranchCardProps) {
  const isClickable = !!onClick;

  return (
    <div
      onClick={onClick}
      className={cn(
        "bg-card border border-border rounded-2xl p-5 shadow-xs flex flex-col justify-between transition-all duration-300 text-left group",
        isClickable
          ? "hover:shadow-md cursor-pointer hover:border-primary/30"
          : "hover:shadow-xs",
        className,
      )}
    >
      <div className="space-y-3">
        <div className="flex items-center gap-2">
          <MapPin className="w-4 h-4 text-primary group-hover:scale-105 transition-transform shrink-0" />
          <h3 className="font-extrabold text-foreground text-sm md:text-base leading-snug">
            {branch.name}
          </h3>
        </div>
        <p className="text-[12px] text-muted-foreground font-semibold leading-relaxed font-sans min-h-[36px]">
          {branch.address}
        </p>
        {branch.extensions && (
          <p className="text-[11px] font-semibold tracking-wider">
            OFICINA: {branch.extensions}
          </p>
        )}
      </div>

      <div className="mt-4 flex flex-row flex-wrap gap-x-3 gap-y-1.5">
        {branch.phones.map((phone, pIdx) => (
          <div
            key={pIdx}
            className="flex items-center gap-2 text-[11px] font-extrabold text-primary hover:text-primary/80 transition-colors"
          >
            <Phone className="w-3.5 h-3.5 shrink-0" />
            <span>{phone}</span>
          </div>
        ))}
      </div>
    </div>
  );
}

export default BranchCard;
